module.exports = "<div class=\"history-info\">\r\n    <span class=\"bold\">Schalter {{ deviceModel.name }}</span><br/>\r\n    <ng2-smart-table [settings]=\"settings\" [source]=\"source\"></ng2-smart-table>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/device-history/device-history.component.html
// module id = ./src/app/components/device-history/device-history.component.html
// module chunks = main